import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvSpin";
let LvSpin = class LvSpin extends UIComponent {
};
__decorate([
    Prop({ type: Number, required: false, default: () => 50 }),
    __metadata("design:type", Number)
], LvSpin.prototype, "size", void 0);
__decorate([
    Prop({ type: String, required: false, default: "#FFFFFF" }),
    __metadata("design:type", String)
], LvSpin.prototype, "color", void 0);
LvSpin = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvSpin);
export default LvSpin;
//# sourceMappingURL=script.js.map